module.exports = __webpack_public_path__ + "static/img/settingsucesse11.7fd39b0f.png";